module.exports = __webpack_public_path__ + "img/ics_o_close.7b2f3e06.svg";